import { Injectable } from "@angular/core";

import { Action, Selector, StateContext, State } from "@ngxs/store";
import { patch } from "@ngxs/store/operators";

import { Ui } from "./ui.actions";

export class UiStateModel {
	sidebarOpen: boolean;
}

@State<UiStateModel>({
	name: "uistate",
	defaults: {
		sidebarOpen: true,
	},
})
@Injectable()
export class UiState {
	@Selector()
	static sidebarOpen(state: UiStateModel) {
		return state.sidebarOpen;
	}

	@Action(Ui.ToggleSidebar)
	toggleSidebar(ctx: StateContext<UiStateModel>) {
		const current = ctx.getState();
		ctx.patchState({ sidebarOpen: !current.sidebarOpen });
	}
}
